export default __webpack_public_path__ + "static/media/carritoNegro.6d150be5.svg";